import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import {animateShow} from "../../animations/showHideAnimation";
import {isViewMode} from "../../../configs/view_only";

@Component({
  selector: 'app-imports-container',
  templateUrl: './imports-container.component.html',
  styleUrls: ['./imports-container.component.scss'],
  animations: [animateShow],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportsContainerComponent{

  public isOpened = false;
  public Yiit = Yiit;
  public isAvailable = (!isViewMode && (window['POLYLINE_IMPORT_ALLOWED'] || window['CAD_IMPORT_ALLOWED']));
  public isGpxAvailable = window['POLYLINE_IMPORT_ALLOWED'];
  public isCadAvailable = window['CAD_IMPORT_ALLOWED'];

  constructor(private cd: ChangeDetectorRef) { }

  toggleOpen(){
    this.isOpened = !this.isOpened;
    this.cd.detectChanges();
  }
}
